import React from 'react';
import {connect} from 'react-redux';
import {useServiceDomainResults} from './serviceDomainResultsHelper';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useResultsTableDimensions, useBoolean, useToggle} from '../../../utils/hooks';
import SMCTable from '../../../components/core/SMCTable/SMCTable';
import ServiceDomainWizard from '../../Wizards/ServiceDomainWizard';
import DeleteServiceDomainConfirmPasswordModal from '../../PopupPages/DeleteServiceDomainConfirmPasswordModal';
import {isAdminReadOnlySelector} from '../../../store/selectors/user.selectors';
import {helpContextPageUrl} from '../../../conf/Routes';
import SMCTableActions from '../../../components/core/SMCTableActions/SMCTableActions';
import { ServiceDomainFilterSchema } from '../../../api/DBSchema/ServiceDomain';
import ServiceDomainFilterPane from '../../Filters/ServiceDomainFilterPane';

function ServiceDomainResults({
    isAdminReadOnly
}) {

    const [tableWidth, tableHeight] = useResultsTableDimensions();
    const [isNewObjectWindowOpen, openNewObjectWindow, closeNewObjectWindow] = useBoolean(false);
    const [isDeleteModalOpen, openDeleteModal, closeDeleteModal] = useBoolean(false);
    const [isFilterPaneOpen, toggleFilterPane] = useToggle(false);

    const {
        tableContent,
        isFetching,
        isPageLoaded,
        fetchNextPage,
        isLastPage,
        columns,
        sortBasis,
        sortDirection,
        setSort,
        columnsState,
        setColumnsState,
        setDefaultColumnsState,
        rowIdSelector,
        selectedObjects,
        setSelectedObjects,
        columnsWidths,
        setColumnsWidths,
        newObjectCallback,
        reloadButtonOnClick,
        deleteCallback,
        filterObject,
        setFilterObject,
        freeTextSearch,
    } = useServiceDomainResults();
 

    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.serviceDomainResults}>
            <div className="DrawResultsDiv">
                 <SMCTableActions
                        openNewObjectWindow={openNewObjectWindow}
                        reloadButtonOnClick={reloadButtonOnClick}
                        deleteButtonOnClick={openDeleteModal}
                        toggleFilterPane={toggleFilterPane}
                        canCreate={!isAdminReadOnly && !isFetching}
                        canDelete={!isAdminReadOnly && !isFetching}
                        isFetching={isFetching} 
                        tableContent={tableContent}
                        isFilterPaneOpen={isFilterPaneOpen}
                        selectedObjects={selectedObjects}
                        initialSearch={filterObject} 
                        onSearchChange={setFilterObject}
                        searchAttribute={ServiceDomainFilterSchema.freeTextSearch}
                /> 
                <SMCTable
                    columns={columns}
                    columnsState={columnsState}
                    setColumnsState={setColumnsState}
                    setDefaultColumnsState={setDefaultColumnsState}
                    selectedObjects={selectedObjects}
                    setSelectedObjects={setSelectedObjects}
                    hasCheckAll={true}
                    defaultColumnsWidths={columnsWidths}
                    onEndResizingColumns={setColumnsWidths}
                    content={tableContent}
                    sortBasis={sortBasis}
                    sortDirection={sortDirection}
                    setSort={setSort}
                    loading={isFetching}
                    onRequestLoadPage={fetchNextPage}
                    isLastPage={isLastPage}
                    width={tableWidth}
                    height={tableHeight}
                    rowIdSelector={rowIdSelector}
                    isFilterOpen={isFilterPaneOpen}
                    filterElem={
                        <ServiceDomainFilterPane
                            initialFilter={filterObject}
                            onFilterChange={setFilterObject}
                            open={isFilterPaneOpen}
                        />
                    }
                    textToHighlight={freeTextSearch}
                    showEditIcon={false}
                />
                {/* Floating windows */}
                <ServiceDomainWizard
                    isOpen={isNewObjectWindowOpen}
                    onRequestClose={closeNewObjectWindow}
                    onSuccess={newObjectCallback}
                />
                <DeleteServiceDomainConfirmPasswordModal
                    isOpen={isDeleteModalOpen}
                    onRequestClose={closeDeleteModal}
                    onFinish={password => {
                        deleteCallback(password);
                        closeDeleteModal();
                    }}
                />
            </div>
        </SMCPage>
    );
}

const mapStateToProps = state => ({
    isAdminReadOnly: isAdminReadOnlySelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(ServiceDomainResults);